import "./SingleStatusDeals.css";
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

// Controllers Start
// import GetProperties from "../../../controllers/properties/getProperties";
// import GetDealsByStatus from "../../../controllers/Enquiries/GetDealsByStatus";
// import GetLeadsIncludesInArray from "../../../controllers/leads/GetLeadsIncludesInArray";
// import GetAgentsIncludesInArray from "../../../controllers/agents/GetAgentsIncludesInArray";
// import GetAdmin from "../../../controllers/admin/GetAdmin";
// import getSettings from "../../../controllers/settings/getSettings";
// Controllers End

// Functions Start
import { compareDesc } from "date-fns";
import { getAuth } from "firebase/auth";
// import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
// Functions End
import NothingSVG from "../../../assets/images/svg/Nothing.svg";
import DealsCard from "../../../components/Deals/DealsCard/DealsCard";
import GetAllDealsbyStatus from "../../../controllers/deals/GetAllDealsbyStatus";
import HeroLoader from "../../../components/HeroLoader/HeroLoader";
import NoDataFound from "../../../components/Common/NoDataFound/NoDataFound";

// const DEALS_LOT_SIZE = 15;

const SingleStatusDeals = () => {
  const location = useLocation();

  const [Type, setType] = useState("*");

  const [Deals, setDeals] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [paginationIndex, setPaginationIndex] = useState(1);
  const [dealStatus, setDealStatus] = useState("");
  // const [properties,setProperties]=useState({});
  // const [Reset, setReset] = useState(true);
  const lastDealSnapshot = useRef("");
  // const lastSharedSnapshot = useRef("*");
  const limit = useRef(4);

  // const reset = () => {
  //   setDeals([]);
  //   setHasMore(true);
  //   setPaginationIndex(1);
  //   setReset(!Reset);
  // };
  const fetchDeals = () => {
    console.log("fetch called inside");
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        let tempdeals = GetAllDealsbyStatus(
          dealStatus,
          Type,
          uid,
          lastDealSnapshot.current,
          limit.current
        );

        tempdeals.then((deals) => {
          if (deals.length === 0) {
            setHasMore(false);
            return;
          }
          lastDealSnapshot.current = deals[deals.length - 1].doc;

          let TotalDeals = [...Deals, ...deals];

          //filter out duplicated data
          const DealIds = TotalDeals.map(({ id }) => id);
          const UniqueDealIds = Array.from(new Set(DealIds));
          TotalDeals = UniqueDealIds.map((uid) =>
            TotalDeals.filter(({ id }) => uid === id).pop()
          );
          console.log("open", TotalDeals);
          if (deals.length < limit.current) {
            setHasMore(false);
          } else {
            setPaginationIndex(paginationIndex + 1);
          }

          setDeals(TotalDeals);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    switch (location.pathname) {
      // case location.pathname.includes("/user/deals/open"):
      case "/user/deals/open":
        setDealStatus("open");

        break;
      // case location.pathname.includes("/user/deals/won"):
      case "/user/deals/won":
        setDealStatus("won");

        break;
      // case location.pathname.includes("/user/deals/lost"):
      case "/user/deals/lost":
        setDealStatus("lost");

        break;
      // case location.pathname.includes("/user/deals/autolost"):
      case "/user/deals/autolost":
        setDealStatus("Auto Lost");

        break;

      default:
        break;
    }
  }, [location]);

  useEffect(() => {
    console.log("useEfffect called");
    if (dealStatus !== "") {
      fetchDeals();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealStatus, Type]);

  // const sortEnquiriesArray = (arr) =>
  //   arr.sort((a, b) =>
  //     compareDesc(
  //       new Date(a.createdAt.toDate()),
  //       new Date(b.createdAt.toDate())
  //     )
  //   );

  // // Currency Settings UseEffect Start
  // const [CurrencySettings, setCurrencySettings] = useState({});
  // useEffect(() => {
  //   async function fetchData() {
  //     const settings = await getSettings();
  //     setCurrencySettings(settings);
  //   }
  //   fetchData();
  // }, []);
  //   useEffect(() => {

  //     async function fetchData() {
  //       getAuth().onAuthStateChanged(async ({ uid }) => {
  //         let properties = await GetProperties(uid);

  //         properties = properties.map((e) => {
  //           return {
  //             ...e,
  //             thumbnail:
  //               "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5",
  //           };
  //         });

  //         const TotalProperties = properties.length;
  //         let TargetProperty = 0;

  //         const getImagesArray = async () => {
  //           const { id } = properties[TargetProperty];
  //           const { items } = await listAll(
  //             ref(getStorage(), `/properties/${id}`)
  //           );
  //           let thumbnail;
  //           if (items.length !== 0) thumbnail = await getDownloadURL(items[0]);
  //           else
  //             thumbnail =
  //               "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2Fproperty-avatar.jpg?alt=media&token=84c103e0-6469-4c87-9c14-c8d7f47b75c6";

  //           properties[TargetProperty] = {
  //             ...properties[TargetProperty],
  //             thumbnail,
  //           };

  //           if (++TargetProperty >= TotalProperties) return;
  //           else await getImagesArray();
  //         };

  //         if (properties.length > 0) await getImagesArray();

  //         setProperties([...properties]);
  //       });
  //     }
  //     fetchData();
  //   }, [Type]);
  // Currency Settings UseEffect End

  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const setWindowDimensions = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  useEffect(() => {
    async function fetchData() {
      isMobile && window.location.replace("/user/deals");
    }
    fetchData();
  }, [isMobile]);
  return (
    <div className="global-body-container">
      <div id="single-deals-listing-header">
        <div className="deals-listing title">
          <h2 className="custom-heading">Deals</h2>
          <div className="deals-listing-filters">
            <div
              className={`type ${Type === "*" ? "active" : ""}`}
              onClick={() => {
                setType("*");
                setDeals([]);
                lastDealSnapshot.current = "";
                setHasMore(true);
              }}
            >
              All
            </div>
            <div
              className={`type ${Type === "buy" ? "active" : ""}`}
              onClick={() => {
                setType("buy");
                setDeals([]);
                lastDealSnapshot.current = "";
                setHasMore(true);
              }}
            >
              Buy
            </div>
            <div
              className={`type ${Type === "sale" ? "active" : ""}`}
              onClick={() => {
                setType("sale");
                setDeals([]);
                lastDealSnapshot.current = "";
                setHasMore(true);
              }}
            >
              Sale
            </div>
            <div
              className={`type ${Type === "rent" ? "active" : ""}`}
              onClick={() => {
                setType("rent");
                setDeals([]);
                lastDealSnapshot.current = "";
                setHasMore(true);
              }}
            >
              Rent
            </div>
          </div>
        </div>

        <div className="deals-listing-buttons">
          <button
            className="add-deal-button"
            type="button"
            onClick={() => {
              navigate("/user/deals/add");
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 17V7"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M7 12H17"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
            Add deal
          </button>
        </div>
      </div>

      <div className="" id="single-deals-list-container">
        <div className="single-deal-card-list">
          <div className="single-deal-card-list-header">
            <div className="deal-status">{dealStatus.toUpperCase()}</div>
            <div className="deals-count">
              {Deals.length ? Deals.length + " " : 0 + " "}
              {Deals?.length === 0
                ? "Deals"
                : Deals?.length > 1
                ? "Deals"
                : "Deal"}
            </div>
          </div>

          <InfiniteScroll
            dataLength={Deals.length}
            next={fetchDeals}
            //    style={{"height":300}}
            hasMore={hasMore}
            loader={<ContentLoaderCustom />}
            scrollThreshold={1}
            scrollableTarget="single-deals-list-container"
            style={{ overflow: "inherit" }}
          >
            <div className="single-deal-card-list-body">
              {Deals?.length === 0 && !hasMore && (
                <div className="deals-no-data-svg">
                  <NoDataFound />
                </div>
              )}
              {Deals.map((Deal, index) => {
                //  const propertyObj = properties.filter(
                //    (p) => p !== Deal.property
                //  );
                //  const propertyThumbnail = propertyObj.map((thumb) => {
                //    return thumb.thumbnail;
                //  });

                const {
                  agent,
                  //  comments,
                  currentstatus,
                  interest,
                  client,
                  property,
                  createdAt,
                  //  transaction,
                  id,
                  dealPrice,
                } = Deal;
                return (
                  <Link to={`/user/deals/update/${id}`}>
                    <DealsCard
                      id={id}
                      key={id}
                      agent={agent.id}
                      status={currentstatus}
                      interest={interest}
                      lead={client.id}
                      property={property.id}
                      createdAt={createdAt}
                      // transaction = "",
                      // name = "",
                      dealPrice={dealPrice}
                      thumbnail={
                        property.images
                          ? property.images[0]
                          : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5"
                      }
                      // CurrencySettings={CurrencySettings}
                    />
                  </Link>
                );
              })}
              {/* {Deals.map((deal)=>{
                return (<h1>{deal.id}</h1>)
             })} */}
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};

const ContentLoaderCustom = () => {
  return (
    // <div className="global-body-container h-100 bg-transparent">
    <div className="sk-three-bounce bg-transparent">
      <div className="sk-child sk-bounce1"></div>
      <div className="sk-child sk-bounce2"></div>
      <div className="sk-child sk-bounce3"></div>
    </div>
    // </div>
  );
};

export default SingleStatusDeals;
